import React from "react";
import * as Yup from "yup";
import { parseDateFromFormats } from "../../../utilities/parseDate";
import userACL from "../../../store/access";

export const vinWiseOpening = () => ({
    vin: "",
    cost: "",
    parent_group: "",
    uid_create: userACL.atFetch().uid,
    uid_update: userACL.atFetch().uid,
});

Yup.addMethod(Yup.date, "format", parseDateFromFormats);
export const vinWiseOpeningSchema = Yup.object().shape({
    vin: Yup.string().required("VIN Required"),
    cost: Yup.number()
        .required("Cost Required")
        .typeError("Cost must be a number"),
    parent_group: Yup.string().required("Parent Group Required"),
});

export const searchColumns = [
    {
        Header: <div style={{ textAlign: "left" }}>PARENT GROUP</div>,
        accessor: "parent_group",
        Cell: (row) => (
            <div
                className="ellipsisDiv"
                style={{ textAlign: "left", paddingLeft: "5px", width: "90%" }}
            >
                {row.value &&
                    row.value !== undefined &&
                    row.value !== null &&
                    row.value !== "NULL" &&
                    row.value !== "0" &&
                    row.value !== 0
                    ? row.value
                    : ""}
            </div>
        ),
        classNameGet: "vinWiseOpeningfilter1",
    },
    {
        Header: <div style={{ textAlign: "left" }}>VIN</div>,
        accessor: "vin",
        Cell: (row) => (
            <div
                className="ellipsisDiv"
                style={{ width: "150px", paddingLeft: "8px" }}
                title={
                    row.value &&
                        row.value !== undefined &&
                        row.value !== null &&
                        row.value !== "NULL" &&
                        row.value !== "0" &&
                        row.value !== 0
                        ? row.value
                        : ""
                }
            >
                {row.value &&
                    row.value !== undefined &&
                    row.value !== null &&
                    row.value !== "NULL" &&
                    row.value !== "0" &&
                    row.value !== 0
                    ? row.value
                    : ""}
            </div>
        ),
        classNameGet: "vinWiseOpeningfilter2",
    },
    {
        Header: <div style={{ textAlign: "right", paddingRight: "10%" }}>COST</div>,
        accessor: "cost",
        Cell: (row) => (
            <div
                style={{ textAlign: "right", paddingRight: "10%" }}
                title={
                    row.value &&
                        row.value !== undefined &&
                        row.value !== null &&
                        row.value !== "NULL" &&
                        row.value !== "0" &&
                        row.value !== 0
                        ? row.value
                        : ""
                }
            >
                {row.value &&
                    row.value !== undefined &&
                    row.value !== null &&
                    row.value !== "NULL" &&
                    row.value !== "0" &&
                    row.value !== 0
                    ? row.value
                    : ""}
            </div>
        ),
        classNameGet: "vinWiseOpeningfilter3",
    },
];
